import { FC, useEffect } from 'react';
import { v4 as uuid } from 'uuid';
import { ICountryExchangeDetail } from '../../../../types/countries';
import { IProductDetailId } from '../../../../types/products';
import GeneralInfo from './generalInfo';
import Pricing from './pricing';
import Specs from './specs';
import './Tabs.scss';

interface ISelectTab {
  title: string;
  number: number;
  view: boolean;
}
interface ITypeProduct {
  id: number;
  type: string;
}

interface IProductForm {
  typeProduct: ITypeProduct;
  productDataDetail?: IProductDetailId;
  changeTab: (dataTab: ISelectTab) => void;
  selectTab: ISelectTab;
  setVerifyGeneralInfo: (isVerify: boolean) => void;
  setVerifySpecs: (isVerify: boolean) => void;
  setVerifyPricing: (isVerify: boolean) => void;
  setChangePricing: (change: boolean) => void;
  countriesOpenForSale?: ICountryExchangeDetail[];
  setUpdateInfo: React.Dispatch<React.SetStateAction<boolean>>;
  editIsKit: (isKit: boolean) => void;
  isKit: boolean;
  setProductDataDetail?: (data: IProductDetailId) => void;
  selectedProfiles: number[];
  setSelectedProfiles: React.Dispatch<React.SetStateAction<number[]>>;
}

const Tabs: FC<IProductForm> = ({
  typeProduct,
  productDataDetail,
  changeTab,
  selectTab,
  setVerifyGeneralInfo,
  setVerifySpecs,
  setVerifyPricing,
  setChangePricing,
  countriesOpenForSale,
  setUpdateInfo,
  editIsKit,
  isKit,
  setProductDataDetail,
  setSelectedProfiles,
  selectedProfiles
}: IProductForm) => {
  const listTabs = [
    { title: 'General', number: 1, view: true },
    { title: 'Especificaciones', number: 2, view: typeProduct.id === 6 || typeProduct.id === 7 ? false : true },
    { title: 'Pricing', number: 3, view: true }
  ];

  const changeSelectTab = (dataTab: ISelectTab) => {
    changeTab(dataTab);
  };

  const generateTabs = () => {
    const showTabs = listTabs.filter(tab => tab.view);
    return showTabs.map((item: ISelectTab) => {
      return (
        <div
          key={uuid()}
          className={`section ${selectTab.number === item.number ? 'selectSection' : ''}`}
          onClick={() => {
            changeSelectTab(item);
          }}
        >
          <div className={`textSection ${selectTab?.number === item.number ? 'selectText' : ''}`}>{item.title}</div>
        </div>
      );
    });
  };
  useEffect(() => {
    if (typeProduct.id === 6 || typeProduct.id === 7) {
      setVerifySpecs(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <>
      <div id="customTabs">
        <div className="containerTabs">{listTabs && generateTabs()}</div>
      </div>
      <div className="bodyTabs">
        {typeProduct.id !== 6 && typeProduct.id !== 7 && (
          <>
            <Specs
              productDataDetail={productDataDetail}
              typeProduct={typeProduct}
              numberTab={selectTab?.number}
              setVerifySpecs={setVerifySpecs}
            />
          </>
        )}
        <Pricing
          numberTab={selectTab?.number}
          productDataDetail={productDataDetail}
          setVerifyPricing={setVerifyPricing}
          setChangePricing={setChangePricing}
          countriesOpenForSale={countriesOpenForSale}
        />
        <GeneralInfo
          productDataDetail={productDataDetail}
          setProductDataDetail={setProductDataDetail}
          typeProduct={typeProduct}
          numberTab={selectTab?.number}
          setVerifyGeneralInfo={setVerifyGeneralInfo}
          setUpdateInfo={setUpdateInfo}
          editIsKit={editIsKit}
          isKit={isKit}
          changeTab={changeTab}
          selectedProfiles={selectedProfiles}
          setSelectedProfiles={setSelectedProfiles}
        />
      </div>
    </>
  );
};

export default Tabs;
